
const digest = '1fedabe5d5da7c08a52d9d27ef018c953a6fd8e5aaee6421635eea188ed2ad8c';
const classes = {"wrapper":"_wrapper_kfazh_1","window":"_window_kfazh_13","header":"_header_kfazh_20","body":"_body_kfazh_28","title":"_title_kfazh_35","close":"_close_kfazh_41","qr":"_qr_kfazh_48"};
const css = `._wrapper_kfazh_1 {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

._window_kfazh_13 {
  border-radius: 15px;
  background: #fff;
  width: 438px;
  overflow: hidden;
}

._header_kfazh_20 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-shadow: -3px 7px 13px 0 #f1f7ff;
  padding: 12px 32px 8px 32px;
}

._body_kfazh_28 {
  box-shadow: -3px 7px 13px 0 #f1f7ff;
  background-color: #e1ecfc;
  text-align: center;
  padding: 24px 32px;
}

._title_kfazh_35 {
  font-size: 16px;
  font-weight: 600;
  color: #212357;
}

._close_kfazh_41 {
  font-size: 12px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
}

._qr_kfazh_48 {
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  